import { Controller } from "@hotwired/stimulus";

// TODO: this is a mock content - need change to real content
export default class extends Controller {
  static targets = [
    "text",
    "listsPanel",
    "radioBtn",
    "dropdownWrapper",
    "chevron",
  ];

  connect() {
    if (this.hasTextTarget && this.hasRadioBtnTarget) {
      this._listenToFristEvent();
      this._listenToSecondEvent();

      this.radioBtnTargets.forEach((element) => {
        if (element.checked) {
          this.textTarget.innerHTML = element.value;
        }
      });
    }

    document.addEventListener("click", this._handleOutsideClick.bind(this));
  }

  disconnect() {
    this.element.removeEventListener("first", this._listenToFristEvent);
    this.element.removeEventListener("second", this._listenToSecondEvent);
    document.removeEventListener("click", this._handleOutsideClick.bind(this));
  }

  showSelectedValue(e) {
    this.textTarget.innerHTML = e.target.innerHTML; // show selected value
    this.radioBtnTargets[parseInt(e.target.dataset.index)].checked = true;
  }

  toggleDropdown() {
    this.listsPanelTarget.open = !this.listsPanelTarget.open; // toggle lists panel
    this._updateFocusClass();
  }

  toggleChevron(event) {
    if (this.hasChevronTarget) {
      if (event.currentTarget.open) {
        this.chevronTarget.classList.add("is-open");
      } else {
        this.chevronTarget.classList.remove("is-open");
      }
    }
  }

  _updateFocusClass() {
    if (this.listsPanelTarget.open) {
      this.dropdownWrapperTarget.classList.add(
        "input__dropdown__wrapper--focus"
      );
    } else {
      this.dropdownWrapperTarget.classList.remove(
        "input__dropdown__wrapper--focus"
      );
    }
  }

  _listenToFristEvent() {
    this.element.addEventListener("first", () => {
      this.textTarget.innerHTML = "fist event";
      this.radioBtnTargets[1].checked = true;
    });
  }

  _listenToSecondEvent() {
    this.element.addEventListener("second", () => {
      this.textTarget.innerHTML = "second event";
      this.radioBtnTargets[2].checked = true;
    });
  }

  _handleOutsideClick(event) {
    if (!this.element.contains(event.target)) {
      this.listsPanelTarget.open = false; // close the dropdown
      this._updateFocusClass();
    }
  }
}
